import { render } from "./PatientDataViewer.vue?vue&type=template&id=3a78bb7e&scoped=true"
import script from "./PatientDataViewer.vue?vue&type=script&lang=js"
export * from "./PatientDataViewer.vue?vue&type=script&lang=js"

import "./PatientDataViewer.vue?vue&type=style&index=0&id=3a78bb7e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a78bb7e"]])

export default __exports__